import Api from '@/api'
const resource = 'missions'

export default {
  fetchOngoingMissions () {
    return Api.get(`/${resource}`)
  },

  fetchMissionById (id) {
    return Api.get(`/${resource}/${id}`)
  },

  fetchCustomerLead (missionId, customerId) {
    return Api.get(`/${resource}/${missionId}/leads/${customerId}`)
  },

  createMission (data) {
    return Api.post(`/${resource}`, data)
  },

  updateCustomerMission (missionId, customerId, data) {
    return Api.post(`/${resource}/${missionId}/leads/${customerId}`, data)
  }
}
